"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjyEditor = _interopRequireDefault(require("@/components/editor/zhjyEditor.vue"));
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
var _news = require("@/api/news/news");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      newsTypeList: [],
      newsForm: {
        createTime: "",
        enableNewsUrl: 0,
        id: "",
        newsContent: "",
        newsFile: "",
        newsSummary: "",
        newsTitle: "",
        newsTypeId: "",
        newsUrl: "",
        sort: "",
        uploadFileList: []
      },
      uploadShow: true,
      fileList: [],
      rules: {
        newsTitle: [{
          required: true,
          message: "请输入新闻标题。",
          trigger: "blur"
        }],
        newsTypeId: [{
          required: true,
          message: "请选择新闻分类。",
          trigger: "change"
        }],
        newsSummary: [{
          required: true,
          message: "请填写新闻概述。",
          trigger: "blur"
        }],
        sort: [{
          required: true,
          message: "请填写新闻排序。",
          trigger: "blur"
        }],
        createTime: [{
          required: true,
          message: "请选择创建时间。",
          trigger: "blur"
        }],
        enableNewsUrl: [{
          required: true,
          message: "请选择是否选择外链。",
          trigger: "blur"
        }]
      }
    };
  },
  components: {
    Editor: _zhjyEditor.default,
    FileUpload: _fileUpload.default
  },
  created: function created() {
    //加载新闻分类
    this.getNewsType();
    this.getCurrentTime();
  },
  methods: {
    getNewsType: function getNewsType() {
      var _this2 = this;
      (0, _news.newTypeListAll)().then(function (res) {
        var data = res.data;
        _this2.newsTypeList = data;
      });
    },
    // 提交新闻
    onSubmit: function onSubmit(v) {
      var _this3 = this;
      console.log(this.newsForm);
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _news.newAdd)(_this3.newsForm).then(function (res) {
            if (res.code === 2000) {
              _this3.$message.success("操作成功。");
              _this3.$router.push("/webSet/webSet-news");
            }
          });
        }
      });
    },
    cancel: function cancel() {
      this.$router.push("/webSet/webSet-news");
    },
    getUploadFileData: function getUploadFileData(data) {
      if (data.code == 1) {
        this.newsForm.uploadFileList.push(data);
        this.uploadShow = false;
        this.fileList.push({
          fileName: data.fileName
        });
        this.$message({
          type: "success",
          message: "上传成功"
        });
      }
    },
    del: function del(index) {
      this.$delete(this.fileList, index);
      this.$delete(this.newsForm.uploadFileList, index);
    },
    getCurrentTime: function getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      var yy = new Date().getFullYear();
      var mm = new Date().getMonth() + 1;
      var dd = new Date().getDate();
      var hh = new Date().getHours();
      var mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      var ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      _this.gettime = yy + "-" + (mm < 10 ? "0" + mm : mm) + "-" + (dd < 10 ? "0" + dd : dd) + " " + hh + ":" + mf + ":" + ss;
      this.newsForm.createTime = _this.gettime;
    }
  }
};